import { ListItemIcon, ListItemText, Divider, MenuList, MenuItem, Box } from "@mui/material"
import {
  Layers,
  Search,
  Title,
  Map,
  Tag,
  Theaters,
  Star,
  PlayCircle,
  Videocam,
  Movie,
  AccountBalance,
  PeopleAlt,
  Handshake,
  SwitchAccount,
  ManageAccounts,
  Info,
  AccountTree,
} from "@mui/icons-material"
import { useAuth } from "../auth"
import { Link, useMatch } from "react-router-dom"
import { useTranslation } from "react-i18next"

type ItemProps = {
  icon: React.ReactNode
  text: string
  to: string
  matchPath?: string
  menuClosed: boolean
}

function Item({ icon, text, to, matchPath, menuClosed }: ItemProps) {
  const match = useMatch(matchPath ?? to.replace(/:[^/]+/g, "*"))
  return (
    <MenuItem
      title={text}
      component={Link}
      to={to}
      selected={!!match}
      sx={{
        "&.Mui-selected": {
          backgroundColor: "primary.dark",
          color: "white",
        },
        "&.Mui-selected:hover": {
          backgroundColor: "primary.dark",
        },
      }}
    >
      <ListItemIcon sx={{ minWidth: 40, color: "inherit" }}>{icon}</ListItemIcon>
      {!menuClosed && <ListItemText primary={text} />}
    </MenuItem>
  )
}

// function SubHeader({ text }: { text: string }) {
//   return <ListSubheader>{text}</ListSubheader>
// }

export default function SideMenu({ menuClosed }: { menuClosed: boolean }) {
  const { user } = useAuth()
  const { t, i18n } = useTranslation()
  const lang = i18n.language

  return (
    <div style={{ width: menuClosed ? 56 : 240, maxWidth: menuClosed ? 56 : 240 }} className={`left-menu`}>
      <MenuList sx={{ pt: 1, width: menuClosed ? 56 : 240, maxWidth: menuClosed ? 56 : 240 }} className={`left-menu`}>
        {(user?.ruolo === "amministratore" || user?.is_superuser || user?.ruolo === "operatore") && (
          <Item icon={<Handshake />} text={t("pages.donatori")} to={`/${lang}/donatori`} menuClosed={menuClosed} />
        )}
        <Item
          icon={<SwitchAccount />}
          text={t("pages.produttori")}
          to={`/${lang}/produttori`}
          menuClosed={menuClosed}
          matchPath={`/${lang}/produttori/*`}
        />
        <Item
          icon={<Star />}
          text={t("pages.fondi")}
          to={`/${lang}/fondi`}
          menuClosed={menuClosed}
          matchPath={`/${lang}/fondi/*`}
        />
        <Item
          icon={<Layers />}
          text={t("pages.supporti")}
          to={`/${lang}/supporti`}
          menuClosed={menuClosed}
          matchPath={`/${lang}/supporti/*`}
        />
        <Item
          icon={<PlayCircle />}
          text={t("pages.documenti")}
          to={`/${lang}/documenti`}
          menuClosed={menuClosed}
          matchPath={`/${lang}/documenti/*`}
        />
        <Item
          icon={<Videocam />}
          text={t("pages.file_digitali")}
          to={`/${lang}/files`}
          menuClosed={menuClosed}
          matchPath={`/${lang}/files/*`}
        />
        <Item icon={<Movie />} text={t("pages.sequenze")} to={`/${lang}/sequenze`} menuClosed={menuClosed} />
        {(user?.ruolo === "amministratore" || user?.is_superuser || user?.ruolo === "operatore") && (
          <Item
            icon={<AccountTree />}
            text={t("pages.assemblaggi")}
            to={`/${lang}/assemblaggi`}
            menuClosed={menuClosed}
            matchPath={`/${lang}/assemblaggi/*`}
          />
        )}

        <Divider />
        {(user?.ruolo === "amministratore" || user?.is_superuser || user?.ruolo === "operatore") && (
          <Box>
            <Item icon={<AccountBalance />} text={t("pages.enti")} to={`/${lang}/enti`} menuClosed={menuClosed} />
            <Item icon={<PeopleAlt />} text={t("pages.persone")} to={`/${lang}/persone`} menuClosed={menuClosed} />
            <Item icon={<Map />} text={t("pages.luoghi")} to={`/${lang}/luoghi`} menuClosed={menuClosed} />
            <Item icon={<Title />} text={t("pages.vocabolari")} to={`/${lang}/vocabolari`} menuClosed={menuClosed} />
            <Item icon={<Tag />} text={t("pages.tags")} to={`/${lang}/tags`} menuClosed={menuClosed} />
            <Item icon={<Theaters />} text={t("pages.formati")} to={`/${lang}/formati`} menuClosed={menuClosed} />

            <Divider />
            {(user?.ruolo === "amministratore" || user?.is_superuser) && (
              <Item icon={<ManageAccounts />} text={t("pages.utenti")} to={`/${lang}/utenti`} menuClosed={menuClosed} />
            )}
          </Box>
        )}
        <Item icon={<Search />} text={t("pages.ricerca")} to={`/${lang}/ricerca`} menuClosed={menuClosed} />
        <Item icon={<Info />} text={t("pages.about")} to={`/${lang}/about`} menuClosed={menuClosed} />
      </MenuList>
    </div>
  )
}
